// extracted by mini-css-extract-plugin
export default {"titulo":"Header_titulo__VIsMe","precoTotal":"Header_precoTotal__NzYEF","textWhite":"Header_textWhite__gAqgz"};